<template>
  <div class="modal">
    <div class="modal-content">
      <div class="title-wrapper">
        <h1 class="login-title-primary">Prijava</h1>
        <div class="close-wrapper">
          <span class="close" v-on:click="$emit('close')">
            <div class="bar-1"></div>
            <div class="bar-2"></div>
          </span>
        </div>
      </div>
      <form id="login" v-on:submit.prevent="login()" novalidate="true">
        <div class="form-field">
          <input
            id="email"
            type="text"
            v-bind:style="{ 'border-bottom': isEmailValid ? '' : '1.5px solid #ef5b5b' }"
            v-model="email"
            v-on:change="validateEmail()"
          />
          <label for="email" v-bind:class="email ? 'field-filled' : ''">Email</label>
          <div class="error" v-bind:style="{ display: isEmailValid ? 'none' : 'block' }">
            Unesena email adresa nije valjana.
          </div>
          <div class="error" v-bind:style="{ display: invalidResetAttempt ? 'block' : 'none' }">
            Moraš unijeti e-mail za resetiranje.
          </div>
          <div class="error" v-bind:style="{ display: didResetSucceed ? 'none' : 'block' }">
            Zahtjev za reset neuspješan.
          </div>
          <div class="success" v-bind:style="{ display: didResetSucceed && isResetOver ? 'block' : 'none' }">
            Zahtjev za resetiranjem je poslan. Provjeri e-mail i klikni na link da promijeniš svoju lozinku.
          </div>
        </div>
        <div class="form-field form-field--password">
          <input
            id="password"
            type="password"
            v-bind:style="{ 'border-bottom': isPasswordValid || didLoginSucceed ? '' : '1.5px solid #ef5b5b' }"
            v-model="password"
            v-on:change="validatePassword()"
          />
          <label for="password" v-bind:class="password ? 'field-filled' : ''">Lozinka</label>
          <div
            class="error"
            v-bind:style="{
              display: isPasswordValid ? 'none' : 'block',
              height: isPasswordValid ? '0' : 'initial',
            }"
          >
            Lozinka ne smije biti prazna.
          </div>
          <div class="error" v-bind:style="{ display: didLoginSucceed ? 'none' : 'block' }">
            Unesena je nepostojeća email adresa ili pogrešna lozinka.
          </div>
          <div class="reset-request--container">
            <a v-if="isEmailValid" class="reset-request" v-on:click="sendResetRequest">Zaboravljena lozinka?</a>
          </div>
        </div>
        <button class="button" type="submit" value="submit">Prijava</button>
      </form>
      <div class="register-container">
        <span>Nemaš račun?&nbsp;</span><a v-on:click="$emit('showRegistrationModal')">Registriraj se</a>
      </div>
    </div>
  </div>
</template>

<script>
import { emailRegex } from '@/config';

export default {
  name: 'LoginModal',
  data() {
    return {
      email: '',
      password: '',
      isEmailValid: true,
      isPasswordValid: true,
      didLoginSucceed: true,
      appUrl: '',
      didResetSucceed: true,
      isResetOver: false,
      isResetting: false,
      invalidResetAttempt: false,
    };
  },
  methods: {
    validateEmail: function () {
      this.isEmailValid = emailRegex.test(this.email);
      this.didLoginSucceed = true;
    },
    validatePassword: function () {
      this.isPasswordValid = this.password;
      this.didLoginSucceed = true;
    },
    login: function () {
      this.$axios
        .post(`${this.$API_URL}/login`, {
          email: this.email,
          password: this.password,
        })
        .then(response => {
          localStorage.setItem('token', response.data);
          let role = this.$decode(response.data).roles;
          if (role === 'Administrator') {
            this.$router.push('/admin');

            return;
          }

          this.$router.push('/app');
        })
        .catch(() => {
          this.didLoginSucceed = false;
          setTimeout(() => {
            this.didLoginSucceed = true;
          }, 3000);
        });
    },
    sendResetRequest: function () {
      if (!this.email || !this.isEmailValid) {
        this.invalidResetAttempt = true;
        setTimeout(() => {
          this.invalidResetAttempt = false;
        }, 3000);

        return;
      }

      if (!this.isResetting && this.email && this.isEmailValid) {
        this.isResetting = true;
        this.$axios
          .post(`${this.$API_URL}/user/reset-password-request`, {
            userEmail: this.email,
            appUrl: this.appUrl,
          })
          .then(() => {
            this.isResetting = false;
            this.isResetOver = true;
            this.didResetSucceed = true;
          })
          .catch(() => {
            this.isResetting = false;
            this.didResetSucceed = false;
            setTimeout(() => {
              this.didResetSucceed = true;
            }, 3000);
          });
      }
    },
    getLogo: function (logoSize) {
      return require(`../../assets/logo-${logoSize
        .replace(/\s/g, '')
        .replace(/!/g, '')
        .replace(/\?/g, '')
        .replace(/\./g, '')
        .toLowerCase()}.svg`);
    },
  },
  created() {
    this.appUrl = `${window.location.protocol}//${window.location.host}`;
  },
  mounted() {
    document.body.classList.add('modal-open');
    document.body.classList.add('no-scroll');
  },
  beforeDestroy() {
    document.body.classList.remove('modal-open');
    document.body.classList.remove('no-scroll');
  },
};
</script>

<style scoped>
.modal {
  justify-content: flex-start;
  overflow-y: auto;
}

.modal-content {
  margin-top: 160px;
  margin-left: 205px;
  margin-right: 137px;
  width: 100%;
}

.title-wrapper {
  position: relative;
}

.button {
  padding: 12px 32px;
}

.login-title-primary {
  color: #fff;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 48px;
  font-weight: 800;
  line-height: 58px;
  margin-bottom: 80px;
}

.login-title-secondary {
  color: #5ec4bc;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 50px;
  font-weight: bold;
  line-height: 60px;
  margin-bottom: 20px;
}

.login-title span {
  margin-top: 20px;
}

.error {
  margin-top: 5px;
}

input {
  border: none;
  color: #fff;
  border-bottom: 1.5px solid #fff;
  font-size: 20px;
  padding: 10px 0;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  width: 100%;
  outline: none;
  background: transparent;
  transition: border-bottom 0.2s ease-in-out;
}

input:focus {
  border-bottom: 1.5px solid #30cec2;
  color: #5ec4bc;
}

form > div {
  position: relative;
}

form > div > label {
  position: absolute;
  color: #ffffffcc;
  font-size: 16px;
  line-height: 24px;
  left: 0;
  top: 10px;
  transition: all 0.1s ease;
}

form > div input:focus + label,
form > div > label.field-filled {
  font-size: 12px;
  top: -15px;
}

.close-wrapper {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 8%;
  right: 0;
}

.close {
  position: relative;
  top: 15px;
}

.close:hover .bar-1 {
  transform: translate(-1px, 8px) rotate(225deg);
}

.close:hover .bar-2 {
  transform: translate(-1px, -5px) rotate(-225deg);
}

.bar-1,
.bar-2 {
  width: 35px;
  height: 3px;
  border-radius: 1px;
  background-color: #fff;
  transition: transform 0.5s;
}

.bar-1 {
  margin-bottom: 10px;
  transform: translate(-1px, 8px) rotate(45deg);
}

.bar-2 {
  transform: translate(-1px, -5px) rotate(-45deg);
}

.register-container {
  margin-top: 64px;
  color: #fff;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 18px;
  line-height: 21px;
}

.register-container > a {
  color: #30cec2;
  cursor: pointer;
}

.close {
  cursor: pointer;
}

#login {
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.form-field {
  margin-bottom: 56px;
  width: 100%;
}

.form-field--password {
  margin-bottom: 48px;
}

.reset-request--container {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}

.reset-request {
  display: inline-block;
  color: #5ec4bc;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 18px;
  line-height: 21px;
  cursor: pointer;
}

.register-link {
  font-weight: bold;
  position: relative;
  cursor: pointer;
}

.register-link:after {
  content: '';
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 4px;
  margin-top: -6px;
  right: 0;
  bottom: 0;
  background: #30cec2;
  border-radius: 1px;
}

@media screen and (max-width: 768px) {
  .modal {
    justify-content: center;
  }

  .modal-content {
    margin-top: 58px;
    margin-left: 32px;
    margin-right: 32px;
  }

  .button {
    width: 100%;
  }
}

@media screen and (max-width: 470px) {
  .login-title-primary {
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 66px;
  }

  .close-wrapper {
    top: -10%;
  }

  form > div input:focus + label,
  form > div > label.field-filled {
    font-size: 12px;
    top: -10px;
  }
}

@media screen and (max-width: 410px) {
  .login-title-primary,
  .login-title-secondary {
    font-size: 32px;
    line-height: 38px;
  }
}
</style>
